import {
  Menu
} from '../models';

export const mapMenu = (result) => {

  return result.data
    .map((item) => {

      return {
        attributes: {
          ...item.attributes,
          id: item.id
        }
      };
    })
    .map(item => {
      return new Menu(item).mapToStandard();
    });
};
